import {
  withApiErrorLoggingOnly,
  eolsBaseApi
} from '../../utilities/api.utilities';
import { addSearchParams } from '../../utilities/app.utilities';
import {
  AssignmentDto,
  AssessmentSubmissionDto,
  EolsAssessmentDto,
  AssignmentResultsDto
} from './eols-assessment-service.dtos';

export const fetchAssignments = (courseSectionId: string): Promise<AssignmentDto[]> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get(addSearchParams('/v2/assignment', { courseSectionId }));
  });
};

// This API return full detail of an assignment
export const fetchAssignment = (assignmentId: string): Promise<AssignmentDto> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get(`/v2/assignment/${assignmentId}`);
  });
};

export const postAssessment = (userId: string, assessment: Partial<EolsAssessmentDto>): Promise<EolsAssessmentDto> => {
  return withApiErrorLoggingOnly(() => {
    // eslint-disable-next-line sonarjs/no-duplicate-string
    return eolsBaseApi.post(addSearchParams('/v2/assessment', { userId }), {
      data: assessment
    });
  });
};

export const fetchEolsAssessmentById = (userId: string, assessmentId: number): Promise<EolsAssessmentDto> => {
  return withApiErrorLoggingOnly(() => {
    // eslint-disable-next-line sonarjs/no-duplicate-string
    return eolsBaseApi.get(addSearchParams(`/v2/assessment/${assessmentId}`, { userId }));
  });
};

export const fetchAssessmentByAssignmentIdAndUserId = (userId: string, assignmentId: number): Promise<EolsAssessmentDto> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get(addSearchParams('/v2/assessment', { userId, assignmentId }));
  });
};

export const fetchAssessmentsByAssignmentIdAndUserId = (userId: string, assignmentId: number): Promise<EolsAssessmentDto[]> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get(addSearchParams('/v2/assessment', { userId, assignmentId, filter: 'ALL' }));
  });
};

export const fetchAssignmentResults = (assignmentId: number): Promise<AssignmentResultsDto> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get(`/v2/assignment/${assignmentId}/results`);
  });
};

export const postSubmission = (assessmentSubmission: Partial<AssessmentSubmissionDto>): Promise<AssessmentSubmissionDto> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.post('/v2/assessment/submission', {
      data: assessmentSubmission
    });
  });
};

export const submitAssessmentScore = (
  assessmentId: number,
  assessmentSubmission: Partial<AssessmentSubmissionDto>,
): Promise<AssessmentSubmissionDto> => {
  const submittedAssessmentSubmission: Partial<AssessmentSubmissionDto> = {
    ...assessmentSubmission,
    assessmentId,
  };
  return postSubmission(submittedAssessmentSubmission);
};

export const putAssignment = (assignment: AssignmentDto): Promise<AssignmentDto> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.put('/v2/assignment', { data: assignment });
  });
};

export const fetchEolsAssessmentSubmissions = (assessmentIdList: number[]): Promise<AssessmentSubmissionDto[]> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get(addSearchParams('/v2/assessment/submission', { assessmentIdList }));
  });
};
